import type { ShapeData } from '@/lib/shapes/types/shape-data'
import { EDITOR_PASTEBOARD_SIZE_PT } from '@/lib/photos/photo-placement-config'

/**
 * Geometry for a dim overlay's pasteboard-sized rect and the rotated hole cut into it (via SVG
 * mask) over the shape currently being edited, so that shape and its image render at full
 * brightness regardless of paint order relative to the dim rect. Shared by node-edit mode and
 * crop mode — both fade the rest of the artboard the same way.
 */
export function computeDimOverlayGeom(
  shape: Pick<ShapeData, 'x' | 'y' | 'width' | 'height' | 'rotation'> | null,
  bleedWidth: number,
  bleedHeight: number
): {
  size: number
  left: number
  top: number
  holeX: number
  holeY: number
  rotTransform: string | undefined
} | null {
  if (!shape) return null

  const size = EDITOR_PASTEBOARD_SIZE_PT
  const left = -(size - bleedWidth) / 2
  const top = -(size - bleedHeight) / 2
  const holeX = shape.x - left
  const holeY = shape.y - top
  const rotation = shape.rotation ?? 0
  const rotTransform = rotation
    ? `rotate(${rotation}, ${holeX + shape.width / 2}, ${holeY + shape.height / 2})`
    : undefined

  return { size, left, top, holeX, holeY, rotTransform }
}
